<template>
	<div>
		<div class="pull-right text-right">
			Filter by Academy Id: <input name="filter" type="text" v-model="filter" v-on:blur="updateFilter" v-on:keyup.13="updateFilter" v-validate.initial="filter" data-vv-rules="numeric" placeholder="Academy Id">
		<p  class="text-danger" v-if="errors.has('filter')">invald academy id</p>
		</div>
		<h2>Activity Log</h2>

		<div class="activity-log-container" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
			<table class="table table-striped table-bordered activity-log-table">
				<thead>
					<tr>
						<th>User</th>
						<th>Academy id</th>
						<th>Action</th>
						<th>Time</th>
						<th>Status</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="row in logdata">
						<td>{{row.firstname}} {{row.lastname}}</td>
						<td>{{row.acadid}}</td>
						<td>{{row.action}}</td>
						<td v-timestamp="row.time"></td>
						<td>{{row.status}}</td>
					</tr>
				</tbody>
			</table>
			<loading-bar v-if="loading"></loading-bar>
			<p v-if="end" class="text-center">No More Log Entries</p>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import store from '../data/AppData'
import infiniteScroll from 'vue-infinite-scroll'

Vue.use(infiniteScroll)

export default{
	name: 'activity-log',
	// TODO get action log from server
	computed: {
		logdata () {
			return this.$store.state.activity.log
		},
		filter () {
			return this.$store.state.activity.filter
		},
		loading () {
			return this.$store.state.app.loading
		},
		end () {
			return this.$store.state.activity.end
		}

	},
	methods: {
		loadMore () {
			if (!this.end) {
				store.dispatch('getLogEntries', this)
			}
		},
		updateFilter (e) {
			this.$validator.validateAll()
			let filter = e.target.value
			if (!this.errors.any() && this.$store.state.activity.filter !== filter) {
				store.dispatch('setActivityFilter', filter)
				store.dispatch('getLogEntries', this)
			}
		}
	},
	beforeRouteEnter (to, from, next) {
		if (store.state.activity.log.length) return next()
		store.dispatch('getLogEntries', this).then(res => next())
	},
	beforeMount () {
		store.commit('setSuppressLoading', true)
	},
	beforeDestroy () {
		store.commit('setSuppressLoading', false)
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// ActivityLog.vue?1f2b8ec9